<div class="customers">
    <div class="d-flex">
        <button type="button" class="btn btn-volver mr-auto p-2" (click)="volver()" style="width: 120px; background: #8346fb 0% 0% no-repeat padding-box;">VOLVER</button>
    </div>
    <div class="card" style="padding: 1rem;">
        <div class="card-body" style="padding: 20px;">
            <div class="row">
                <div class="d-flex justify-content-between">
                    <div>
                        <p style="text-align: left;
                            font: normal normal bold 26px/53px Montserrat;
                            letter-spacing: 0px;
                            color: #00B09E;
                            opacity: 1;">Fase Anual</p>
                    </div>
                    <div class="" style="text-align: left;">
                        <div class="d-flex justify-content-end" style="background: #F6F6F6 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        padding: 15px;
                        ">
                            <p class="info-label">JARDÍN INFANTIL: </p>

                            <p class="info-data">{{dataJardin.jardin}}</p>

                            <p class="info-label">CÓDIGO: </p>

                            <p class="info-data">{{dataJardin.rbd}}</p>

                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
                <mat-spinner style="margin-top: 15%;margin-left: 35vw;"></mat-spinner>
            </div>
            <div class="row" [style.display]="!cargando ? '' : 'none'">
                <div class="col-sm-12">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#area-year-1">{{ faseAnualData?.periodos[0]?.anio }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#area-year-2">{{ faseAnualData?.periodos[1]?.anio }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#area-year-3">{{ faseAnualData?.periodos[2]?.anio }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link">{{ faseAnualData?.periodos[3]?.anio }}</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="area-year-1">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="btn-guardar" style="margin-left: 25px;color: #F5BB3F;background: #FFF;text-align: center;width: 400px;border: #F5BB3F 1px solid;padding-top: 10px;">
                                        <p class="statusname" *ngIf="faseAnualData.periodos[0]?.estado === 0">estado: Fase Anual 2024 No iniciada</p>
                                        <p class="statusname" *ngIf="faseAnualData.periodos[0]?.estado === 1">estado: Fase Anual 2024 Iniciada</p>
                                        <p class="statusname" *ngIf="faseAnualData.periodos[0]?.estado === 2">estado: Fase Anual 2024 Finalizada</p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="d-flex flex-row-reverse" *ngIf="faseAnualData.estado < 4">
                                        <div *ngIf="faseAnualData.periodos[0]?.estado <= 1">
                                            <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseAnual(faseAnualData.periodos[0])" >GUARDAR AVANCES</button> 
                                            <button type="button" class="btn btn-enviar p-2" (click)="validarFinalizar(faseAnualData.periodos[0])">FINALIZAR Y ENVIAR</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <br>
                            <div *ngFor="let dimensionData of faseAnualData?.periodos[0]?.dimensiones; let indice=index">
                                <app-pme-dimensiones-fase-anual [estadoData]="dimensionData.estado" [dimensionData]="dimensionData" [dataJardin]="dataJardin" [simulacion]="simulacion"></app-pme-dimensiones-fase-anual>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="area-year-2">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="btn-guardar" style="margin-left: 25px;color: #F5BB3F;background: #FFF;text-align: center;width: 400px;border: #F5BB3F 1px solid;padding-top: 10px;">
                                        <p class="statusname" *ngIf="faseAnualData.periodos[1]?.estado === 0">estado: Fase Anual 2025 No iniciada</p>
                                        <p class="statusname" *ngIf="faseAnualData.periodos[1]?.estado === 1">estado: Fase Anual 2025 Iniciada</p>
                                        <p class="statusname" *ngIf="faseAnualData.periodos[1]?.estado === 2">estado: Fase Anual 2025 Finalizada</p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="d-flex flex-row-reverse" *ngIf="faseAnualData.estado >= 4 && faseAnualData.estado < 6">
                                        <div *ngIf="faseAnualData.periodos[1]?.estado <= 1">
                                            <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseAnual(faseAnualData.periodos[1])" >GUARDAR AVANCES</button> 
                                            <button type="button" class="btn btn-enviar p-2" (click)="validarFinalizar(faseAnualData.periodos[1])">FINALIZAR Y ENVIAR</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div *ngFor="let dimensionData of faseAnualData?.periodos[1]?.dimensiones; let indice=index">
                                <app-pme-dimensiones-fase-anual [estadoData]="dimensionData.estado" [dimensionData]="dimensionData" [dataJardin]="dataJardin" [simulacion]="simulacion"></app-pme-dimensiones-fase-anual>
                            </div>
                            
                            <div class="d-flex flex-row-reverse" *ngIf="faseAnualData.estado >= 4 && faseAnualData.estado < 6">
                                <div *ngIf="faseAnualData.periodos[1]?.estado <= 1">
                                    <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseAnual(faseAnualData.periodos[1])" >GUARDAR AVANCES</button> 
                                    <button type="button" class="btn btn-enviar p-2" (click)="validarFinalizar(faseAnualData.periodos[1])">FINALIZAR Y ENVIAR</button>
                                </div>
                            </div>
                            
                        </div>
                        <div class="tab-pane fade" id="area-year-3">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="btn-guardar" style="margin-left: 25px;color: #F5BB3F;background: #FFF;text-align: center;width: 400px;border: #F5BB3F 1px solid;padding-top: 10px;">
                                        <p class="statusname" *ngIf="faseAnualData.periodos[2]?.estado === 0">estado: Fase Anual 2026 No iniciada</p>
                                        <p class="statusname" *ngIf="faseAnualData.periodos[2]?.estado === 1">estado: Fase Anual 2026 Iniciada</p>
                                        <p class="statusname" *ngIf="faseAnualData.periodos[2]?.estado === 2">estado: Fase Anual 2026 Finalizada</p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="d-flex flex-row-reverse" *ngIf="faseAnualData.estado >= 6 && faseAnualData.estado < 8">
                                        <div *ngIf="faseAnualData.periodos[2]?.estado <= 1">
                                            <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseAnual(faseAnualData.periodos[2])" >GUARDAR AVANCES</button> 
                                            <button type="button" class="btn btn-enviar p-2" (click)="validarFinalizar(faseAnualData.periodos[2])">FINALIZAR Y ENVIAR</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div *ngFor="let dimensionData of faseAnualData?.periodos[2]?.dimensiones; let indice=index">
                                <app-pme-dimensiones-fase-anual [estadoData]="dimensionData.estado" [dimensionData]="dimensionData" [dataJardin]="dataJardin" [simulacion]="simulacion"></app-pme-dimensiones-fase-anual>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="area-year-4">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="btn-guardar" style="margin-left: 25px;color: #F5BB3F;background: #FFF;text-align: center;width: 400px;border: #F5BB3F 1px solid;padding-top: 10px;">
                                        <p class="statusname" *ngIf="faseAnualData.periodos[3]?.estado === 0">estado: Fase Anual 2027 No iniciada</p>
                                        <p class="statusname" *ngIf="faseAnualData.periodos[3]?.estado === 1">estado: Fase Anual 2027 Iniciada</p>
                                        <p class="statusname" *ngIf="faseAnualData.periodos[3]?.estado === 2">estado: Fase Anual 2027 Finalizada</p>
                                    </div>
                                </div>
                                <!--div class="col-sm-6">
                                    < div class="d-flex flex-row-reverse" *ngIf="faseAnualData.estado >= 8 && faseAnualData.estado < 10">
                                        <div *ngIf="faseAnualData.periodos[3]?.estado <= 1" >
                                            <button type="button" class="btn btn-guardar p-2" (click)="guardarFaseAnual(faseAnualData.periodos[3])" >GUARDAR AVANCES</button> 
                                            <button type="button" class="btn btn-enviar p-2" (click)="validarFinalizar(faseAnualData.periodos[3])">FINALIZAR Y ENVIAR</button>
                                        </div>
                                    </div>
                                </div-->
                            </div>
                            <br>
                            <div *ngFor="let dimensionData of faseAnualData?.periodos[3]?.dimensiones; let indice=index">
                                <app-pme-dimensiones-fase-anual [estadoData]="dimensionData.estado" [dimensionData]="dimensionData" [dataJardin]="dataJardin" [simulacion]="simulacion"></app-pme-dimensiones-fase-anual>
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
        </div>
    </div>
</div>